import {Component, inject} from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";
import {UpperCasePipe} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ButtonModule} from "primeng/button";
import {TextareaModule} from "primeng/textarea";
import {DynamicDialogRef} from "primeng/dynamicdialog";

@Component({
    selector: 'app-config-reactivate-popup',
    imports: [
        TranslatePipe,
        UpperCasePipe,
        ButtonModule,
        TextareaModule,
        FormsModule,
    ],
    templateUrl: './config-reactivate-popup.component.html',
    styleUrl: './config-reactivate-popup.component.scss'
})
export class ConfigReactivatePopupComponent {
    private readonly dialogRef = inject(DynamicDialogRef);

    reason = ''

    cancel() {
        this.dialogRef.close(false);
    }

    confirm() {
        this.dialogRef.close(this.reason);
    }
}
